import { MarginInterface } from '../../types';
import { stringOrNumberHelper } from './stringOrNumberHelper';

export const marginDecorator = ({
	m,
	mt,
	mr,
	mb,
	ml,
	mx,
	my,
}: MarginInterface) => {
	let response = '';
	if (mt) {
		response += `margin-top: ${stringOrNumberHelper(mt)};`;
	}
	if (mr) {
		response += `margin-right: ${stringOrNumberHelper(mr)};`;
	}
	if (mb) {
		response += `margin-bottom: ${stringOrNumberHelper(mb)};`;
	}
	if (ml) {
		response += `margin-left: ${stringOrNumberHelper(ml)};`;
	}
	if (mx) {
		response += `
      margin-left: ${stringOrNumberHelper(
				mx
			)}; margin-right: ${stringOrNumberHelper(mx)};
    `;
	}
	if (my) {
		response += `
      margin-top: ${stringOrNumberHelper(
				my
			)}; margin-bottom: ${stringOrNumberHelper(my)};
    `;
	}
	if (m) {
		response += `margin: ${stringOrNumberHelper(m)};`;
	}
	return response;
};
